const interpolateColorWithAlpha = (start, end, factor) => {
   const result = start.slice();

   for (let i = 0; i < 3; i++) {
      result[i] = Math.round(result[i] + factor * (end[i] - start[i]));
   }

   // Interpoliraj i alfa kanal (index 3)
   const alpha = start[3] + factor * (end[3] - start[3]);
   return `rgba(${result[0]},${result[1]},${result[2]},${alpha.toFixed(2)})`;
};

export const getBgColor = (mp) => {
   const breakpoints = [1, 2, 5, 10];

   const colors = [
      [52, 180, 255, 0.7],
      [145, 62, 248, 0.7],
      [175, 36, 165, 0.4],
      [218, 8, 50, 0.4],
   ];

   for (let i = 1; i < breakpoints.length; i++) {
      if (mp <= breakpoints[i]) {
         const localFactor = (mp - breakpoints[i - 1]) / (breakpoints[i] - breakpoints[i - 1]);
         const colorStart = colors[i - 1];
         const colorEnd = colors[i];
         const centerColor = interpolateColorWithAlpha(colorStart, colorEnd, localFactor);

         return `radial-gradient(50% 50% at 50% 50%, ${centerColor} 0%, rgba(${colorEnd[0]},${colorEnd[1]},${colorEnd[2]},0) 100%)`;
      }
   }

   const lastColor = colors[colors.length - 1];
   return `radial-gradient(50% 50% at 50% 50%, rgba(${lastColor[0]},${lastColor[1]},${lastColor[2]},${lastColor[3]}) 0%, rgba(${lastColor[0]},${lastColor[1]},${lastColor[2]},0) 100%)`;
};

// Primer poziva
// console.log(getBgColor(3));
